export default "__VITE_ASSET__B9lP1LsW__"